import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import TrackInteractionsImage from './TrackInteractionsImage'

const copy = {
  heading: `Track every interaction in real time`,
  description: `Gain a deep understanding of your customer behavior as it evolves in real time across web, mobile, server, and third-party touchpoints.`,
}

const TrackInteractions: FC = () => (
  <StyledSectionBase variant="2Col" reverse={true}>
    <Section.Contents>
      <TrackInteractionsImage alt={`Illustration: ${copy.heading}`} />
    </Section.Contents>
    <StyledCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Heading tag="h2" variant="h2">
          {copy.heading}
        </CopyText.Heading>
        <CopyText.Description tag="p" variant="pLarge">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </StyledCopy>
  </StyledSectionBase>
)

export default TrackInteractions

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
